import { Routes } from "@angular/router";
import { LoggedOutComponent } from "../loggedout/components/loggedout/loggedout.component";


export const LOGGEDOUT_ROUTES: Routes = [
    {
        path: 'loggedout',
        children: [
            { path: '', component: LoggedOutComponent }
        ]
    }
];
